<template>
	<div>
		<the-header />
		<the-progress-bar
			:steps="completedSteps"
		/>

		<div class="main-app">
			<div class="shell">
				<transition name="no-mode-translate-fade" mode="out-in">
					<router-view></router-view>
				</transition>
			</div><!-- /.shell -->
		</div><!-- /.main-app -->
	</div>
</template>

<script>

/**
 * Internal Dependencies
 */
import TheHeader from './components/TheHeader.vue';
import TheProgressBar from './components/TheProgressBar.vue';
import { mapGetters} from 'vuex';

export default {
	components: {
		TheHeader,
		TheProgressBar
	},

	computed: {
		/**
		 * Map Store's Getters
		 */
		...mapGetters({
			'steps': 'getSteps',
		}),

		completedSteps(){
			let counter = 0;
			Object.values(this.steps).forEach(step => {
				if (step === true) {
					counter++
				}
			})

			return counter;
		}
	}
};
</script>

<style>
	.main-app { background: #f7f3ee; }
	.main-app .shell { max-width: 810px; }

	.section-app { padding: 50px 0; }
	.section-app .section__container { position: relative;  }
	.section-app .section__container:before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
	.section-app .section__foot { text-align: center; padding-top: 35px; }
	.section-app .section__foot .btn { margin: 5px; }
	.section-app .section__notice { font-size: 14px; text-align: center; padding-top: 10px; font-weight: 700; }

	.no-mode-translate-fade-leave-active {transition: all .3s .1s; }

	.no-mode-translate-fade-enter-active { transition: all .4s; }

	.no-mode-translate-fade-enter,
	.no-mode-translate-fade-leave-active {opacity: 0; }
	.no-mode-translate-fade-enter {transform: translateX(31px); }
	.no-mode-translate-fade-leave-active {transform: translateX(-31px); }

	@media(max-width: 767px){
		.section-app { padding: 30px 0;  }
		.section-app .section__foot { padding-top: 25px;  }
	}
</style>


// WEBPACK FOOTER //
// src/App.vue